"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputButton = exports.HiddenInput = exports.InputButtonLabel = exports.RoundLinkButton = exports.RoundButton = exports.LinkButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(["\n  ", "\n  border-radius: 2px;\n  padding: ", ";\n"], ["\n  ", "\n  border-radius: 2px;\n  padding: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  line-height: 1.25;\n  border-radius: 100px;\n  padding: ", ";\n"], ["\n  ", "\n  line-height: 1.25;\n  border-radius: 100px;\n  padding: ", ";\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  line-height: 1.25;\n  border-radius: 100px;\n  ", ";\n  ", ";\n  padding: ", ";\n  padding: ", ";\n  \n"], ["\n  ", "\n  line-height: 1.25;\n  border-radius: 100px;\n  ", ";\n  ", ";\n  padding: ", ";\n  padding: ", ";\n  \n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n      @media (min-width: 600px) {\n        height: 60px;\n      }\n      @media (max-width: 600px) {\n        height: 50px;\n      }\n      @media (max-width: 400px) {\n        height: 45px;\n      }\n      width: 80%;\n      margin: 10px auto auto auto;\n    "], ["\n      @media (min-width: 600px) {\n        height: 60px;\n      }\n      @media (max-width: 600px) {\n        height: 50px;\n      }\n      @media (max-width: 400px) {\n        height: 45px;\n      }\n      width: 80%;\n      margin: 10px auto auto auto;\n    "]),
    _templateObject5 = _taggedTemplateLiteral(["\n      @media (min-width: 600px) {\n        width: 60%;\n      }\n  "], ["\n      @media (min-width: 600px) {\n        width: 60%;\n      }\n  "]),
    _templateObject6 = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n\n  :focus + label {\n    outline: thin dotted;\n    outline: 5px auto #0042CB;\n    outline-offset: -2px;\n    color: #0042CB;\n    background-color: #fff;\n  }\n\n  :checked + label,\n  :hover + label {\n    border: solid 1px ", ";\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n\n  :focus + label {\n    outline: thin dotted;\n    outline: 5px auto #0042CB;\n    outline-offset: -2px;\n    color: #0042CB;\n    background-color: #fff;\n  }\n\n  :checked + label,\n  :hover + label {\n    border: solid 1px ", ";\n    color: ", ";\n    background-color: ", ";\n  }\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Arrow = require("./images/Arrow");

var _Arrow2 = _interopRequireDefault(_Arrow);

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonContainer = _styledComponents2.default.button.withConfig({
  displayName: "src__ButtonContainer",
  componentId: "sc-189acn6-0"
})(_templateObject, _style.ButtonStyle, function (props) {
  return props.large ? "16px 24px 16px" : "8px 20px 8px";
});

var LinkButtonContainer = _styledComponents2.default.a.attrs({ role: "button" }).withConfig({
  displayName: "src__LinkButtonContainer",
  componentId: "sc-189acn6-1"
})(_templateObject, _style.ButtonStyle, function (props) {
  return props.large ? "16px 24px 16px" : "8px 20px 8px";
});

var Button = function Button(props) {
  return _react2.default.createElement(
    ButtonContainer,
    _extends({}, props, {
      onClick: function onClick() {
        !props.disabled ? props.onClick() : null;
      }
    }),
    props.children,
    props.arrow && _react2.default.createElement(_Arrow2.default, null)
  );
};

var LinkButton = exports.LinkButton = function LinkButton(props) {
  return _react2.default.createElement(
    LinkButtonContainer,
    _extends({
      tabIndex: props.tabIndex || "0"
    }, props, {
      onClick: function onClick() {
        !props.disabled ? props.onClick() : null;
      }
    }),
    props.children,
    props.arrow && _react2.default.createElement(_Arrow2.default, null)
  );
};

var RoundButtonContainer = _styledComponents2.default.button.withConfig({
  displayName: "src__RoundButtonContainer",
  componentId: "sc-189acn6-2"
})(_templateObject2, _style.ButtonStyle, function (props) {
  return props.large ? "16px 30px" : "13px 30px";
});

var RoundLinkButtonContainer = _styledComponents2.default.a.attrs({ role: "button" }).withConfig({
  displayName: "src__RoundLinkButtonContainer",
  componentId: "sc-189acn6-3"
})(_templateObject3, _style.ButtonStyle, function (props) {
  return (props.covidModal || props.secondary) && (0, _styledComponents.css)(_templateObject4);
}, function (props) {
  return props.secondary && (0, _styledComponents.css)(_templateObject5);
}, function (props) {
  return props.large ? "16px 30px" : "13px 30px";
}, function (props) {
  return props.covidModal ? "14px 24px" : "";
});

var RoundButton = exports.RoundButton = function RoundButton(props) {
  return _react2.default.createElement(
    RoundButtonContainer,
    _extends({}, props, {
      onClick: function onClick() {
        !props.disabled ? props.onClick() : null;
      }
    }),
    props.children,
    props.arrow && _react2.default.createElement(_Arrow2.default, null)
  );
};

var RoundLinkButton = exports.RoundLinkButton = function RoundLinkButton(props) {
  return _react2.default.createElement(
    RoundLinkButtonContainer,
    _extends({
      tabIndex: props.tabIndex || "0"
    }, props, {
      onClick: function onClick() {
        !props.disabled ? props.onClick() : null;
      }
    }),
    props.children,
    props.arrow && _react2.default.createElement(_Arrow2.default, null)
  );
};

var InputButtonLabel = exports.InputButtonLabel = _styledComponents2.default.label.withConfig({
  displayName: "src__InputButtonLabel",
  componentId: "sc-189acn6-4"
})(_templateObject, _style.ButtonStyle, function (props) {
  return props.large ? "16px 24px 16px" : "8px 20px 8px";
});

var HiddenInput = exports.HiddenInput = _styledComponents2.default.input.withConfig({
  displayName: "src__HiddenInput",
  componentId: "sc-189acn6-5"
})(_templateObject6, _style.hoverBorderColor, _style.hoverTextColor, _style.hoverColor);

var InputButton = function InputButton(_ref) {
  var children = _ref.children,
      labelFor = _ref.labelFor,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["children", "labelFor", "onClick"]);

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(HiddenInput, _extends({}, props, {
      id: labelFor,
      name: props.name,
      type: props.inputType,
      value: props.value,
      onClick: onClick
    })),
    _react2.default.createElement(
      InputButtonLabel,
      _extends({}, props, { htmlFor: labelFor }),
      children
    )
  );
};

exports.InputButton = InputButton;
var propTypes = {
  // OnClick handler for button
  onClick: _propTypes2.default.func.isRequired,
  // When the button is in it's disabled state
  disabled: _propTypes2.default.bool,
  // Optional arrow graphic, used in landing page
  arrow: _propTypes2.default.bool,
  // Large button style: used in landing page
  large: _propTypes2.default.bool,
  // Ghost button style: the text and border color take on
  // the color prop passed and the background is transparent.
  ghost: _propTypes2.default.bool,
  // Color of button background. Supply only this color argument
  // for automatic color handling for hover/disabled/border states.
  color: _propTypes2.default.string,
  // Overridable colors for super custom buttons. Not compatible with
  // the ghost prop.
  textColor: _propTypes2.default.string,
  // If not defined uses text color
  hoverTextColor: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.string,
  hoverBackgroundColor: _propTypes2.default.string,
  borderColor: _propTypes2.default.string,
  // If not defined uses borderColor
  hoverBorderColor: _propTypes2.default.string
};

var propTypesLink = propTypes;
propTypesLink["onClick"] = _propTypes2.default.func;

var defaultProps = {
  color: "primary"
};

Button.defaultProps = defaultProps;

LinkButton.defaultProps = defaultProps;

RoundButton.defaultProps = defaultProps;

RoundLinkButton.defaultProps = defaultProps;

InputButton.defaultProps = defaultProps;

Button.propTypes = propTypes;

LinkButton.propTypes = propTypesLink;

RoundButton.propTypes = propTypes;

RoundLinkButton.propTypes = propTypesLink;

InputButton.propTypes = _extends({}, propTypes, {
  labelFor: _propTypes2.default.string.isRequired,
  inputType: _propTypes2.default.oneOf(["radio", "checkbox"]).isRequired,
  name: _propTypes2.default.string.isRequired
});

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-button/dist/index.js
// module id = 48
// module chunks = 168707334958949